import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    onSnapshot,
    orderBy,
    query,
    Timestamp,
    where,
    writeBatch
} from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Button,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    MenuItem,
    Pagination,
    Chip
} from "@mui/material";

import {
    Add,
    Visibility,
    Close,
    SwapHoriz
} from "@mui/icons-material";


function Viewreservations() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [bookings, setbookings] = useState([]);
    const [username, setusername] = useState();
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [searchText, setsearchText] = useState("");
    const [bookingId, setbookingId] = useState("");
    const [requestType, setrequestType] = useState("Exchange Room");
    const [requestNote, setrequestNote] = useState("");
    const [roomUsed, setroomUsed] = useState("No");

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(10); // configurable

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'reservations'), orderBy("createdAt", "asc"), where('status', '==', 'Booked'))
            onSnapshot(q, (querySnapshot) => {
                setbookings(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
                setCurrentPage(1); // reset to first page on new data
            });
        } catch (error) {
            console.log(error.message);
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = bookings.filter((item) =>
                item.data.customers.custname.toUpperCase().includes(searchText.toUpperCase())
            );
            setbookings(filteredData);
            setCurrentPage(1);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const storeRequest = async () => {
        if (!bookingId || !requestType || !requestNote) {
            Toast.fire({ icon: "error", title: 'Request Note or Request Type should not be blank' });
            return
        }

        await addDoc(collection(db, 'approvals'), {
            bookingid: bookingId,
            requestType: requestType,
            requestNote: requestNote,
            status: 'Pending',
            rejectedreason: '',
            updatedat: "",
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
        });

        setrequestNote("");
        Toast.fire({ icon: "success", title: 'Approval Request send to the GM' });

    }

    const cancleBooking = async () => {
        const bookingRef = doc(db, "reeservations", bookingId);
        const batch = writeBatch(db);

        batch.update(bookingRef, { status: "Canceled" });

        const checkinDetailsQuery = query(collection(db, 'checkindetails'), where('bookingid', '==', bookingId));
        const checkinDetailsSnapshot = await getDocs(checkinDetailsQuery);
        checkinDetailsSnapshot.docs.forEach(item => {
            const checkinRef = doc(db, "checkindetails", item.id);
            batch.update(checkinRef, { status: "Canceled" });
        });

        const payHistoryQuery = query(collection(db, 'payhistory'), where('bookingid', '==', bookingId));
        const payHistorySnapshot = await getDocs(payHistoryQuery);
        payHistorySnapshot.docs.forEach(item => {
            const payHistoryRef = doc(db, "payhistory", item.id);
            batch.update(payHistoryRef, { status: "Canceled" });
        });

        const bookingSnap = await getDoc(bookingRef);
        const rooms = bookingSnap.data().rooms;
        rooms.forEach(room => {
            const roomRef = doc(db, "roomdetails", room.roomid);
            const status = roomUsed === 'Yes' ? 'Cleaning' : 'Available';
            batch.update(roomRef, { status });
        });

        await addDoc(collection(db, 'logs'), {
            bookingid: bookingId,
            customerId: bookingSnap.data().customerId,
            customers: bookingSnap.data().customers,
            rooms: rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Booking Cancellation',
        });

        await batch.commit();
        Toast.fire({ icon: "success", title: 'Room Successfully Canceled' });
    }

    // Pagination calculations
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = bookings.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(bookings.length / rowsPerPage);

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(prev => prev - 1);
    };

    return (
        <Box >
            <Menu />

            <Box className="content-wrapper" p={2} bgcolor="#f5f7fb" minHeight="100vh">
                <Typography variant="h5" fontWeight={800} mb={2}>
                    View Reservations
                </Typography>

                <Card sx={{ borderRadius: 3 }}>
                    <CardContent>

                        {/* Search */}
                        <Box mb={2} maxWidth={300}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Search customer..."
                                value={searchText}
                                onChange={(e) => setsearchText(e.target.value)}
                            />
                        </Box>

                        {/* Table */}
                        <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ bgcolor: "#eef2ff" }}>
                                        <TableCell>Sr</TableCell>
                                        <TableCell>Rooms</TableCell>

                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {currentRows.map((item, index) => (
                                        <TableRow key={item.id} hover>
                                            <TableCell>{indexOfFirstRow + index + 1}</TableCell>

                                            <TableCell>
                                                {item.data.rooms.map((r, i) => (
                                                    <Chip
                                                        key={i}
                                                        label={r.roomno}
                                                        size="small"
                                                        sx={{ mr: 0.5, mb: 0.5 }}
                                                    />
                                                ))}
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {/* Pagination */}
                        <Box display="flex" justifyContent="center" mt={3}>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={(e, v) => setCurrentPage(v)}
                                color="primary"
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>

    )
}

export default Viewreservations;
